import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background-50 px-4 text-center">
      <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 bg-background-100 rounded-full">
        <i className="ri-emotion-sad-line text-3xl text-foreground-400"></i>
      </div>
      <h1 className="text-6xl md:text-8xl font-heading font-bold text-foreground-200 mb-4">
        404
      </h1>
      <h2 className="text-xl font-heading font-semibold text-foreground-950 mb-2">
        页面未找到
      </h2>
      <p className="text-foreground-600 text-sm max-w-md mb-8">
        抱歉，您要访问的页面不存在或已被移除。请检查链接是否正确，或返回首页继续浏览。
      </p>
      <Link
        to="/"
        className="px-6 py-2.5 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
      >
        <i className="ri-home-4-line mr-1.5"></i>
        返回首页
      </Link>
    </div>
  );
}